import React, { useEffect, useState } from 'react';
import { actionsCart } from '../../redux/cart/cartReducer';
import { useDispatch } from 'react-redux';
import CountInput, { countInputEventType } from '../Forms/Components/CountInput';
import { ICartItem } from '../../typings/ICartItem';
import { ID_UNIT_WEIGHT } from '../../constants/constantsId';
import { DL_helper } from '../../utils/DataLayer/DL_helper';
import { DlEcommerceEvents, DlEventSource } from '../../utils/DataLayer/constant';

interface ICartCountItemProps {
  item: ICartItem;
  dlEcommerceEventSource: DlEventSource;
  dlItemIndex?: number;
}

const CartCountItem = React.memo(({ item, dlEcommerceEventSource, dlItemIndex }: ICartCountItemProps) => {
  const dispatch = useDispatch<any>();
  const [dlProcessingEventData, setDlProcessingEventData] = useState<{
    actualCountForDL: number;
    prevPrice: string | undefined;
    isDecr: boolean;
  } | null>(null);
  const { product } = item;
  const isWeight = product.units === ID_UNIT_WEIGHT;

  useEffect(() => {
    if (!dlProcessingEventData || !item) {
      return;
    }
    if (Number(dlProcessingEventData.prevPrice) !== Number(item.price)) {
      setDlProcessingEventData(null);
      const actualCountForDL = dlProcessingEventData.actualCountForDL;
      if (dlProcessingEventData.isDecr) {
        DL_helper(item, DlEcommerceEvents.REMOVE_FROM_CART, actualCountForDL, dlEcommerceEventSource, dlItemIndex);
        return;
      }
      DL_helper(item, DlEcommerceEvents.ADD_TO_CART, actualCountForDL, dlEcommerceEventSource, dlItemIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dlProcessingEventData, item]);

  const onChange = (count: number, eventType: countInputEventType) => {
    const prevCount = Number(item.count);
    if (prevCount === count) {
      return;
    }

    let actualCountForDL = Math.abs(prevCount - count);
    if (count === 0) {
      dispatch(actionsCart.removeProduct(product.id));
      DL_helper(item, DlEcommerceEvents.REMOVE_FROM_CART, actualCountForDL, dlEcommerceEventSource, dlItemIndex);
    }
    if (!item.alternativeCount) {
      dispatch(
        actionsCart.changeCount({
          count,
          id: product.id,
        }),
      );
    } else {
      dispatch(
        actionsCart.changeCount({
          count: count * +item.product.avgWeight!,
          id: product.id,
        }),
      );
      dispatch(
        actionsCart.changeAlternativeCount({
          count,
          id: product.id,
        }),
      );
      actualCountForDL = actualCountForDL * +item.product.avgWeight!;
    }

    setDlProcessingEventData({
      actualCountForDL,
      prevPrice: item.price,
      isDecr: eventType === 'decr' || prevCount > count,
    });
  };

  const count = item.alternativeCount ? +item.alternativeCount : +item.count;

  return (
    <CountInput
      isEditable={true}
      isWeightUnit={item.alternativeCount !== null ? false : isWeight}
      onChange={onChange}
      value={count}
      isRemove={true}
    />
  );
});

export default CartCountItem;
